import { Calendar } from "primereact/calendar";
import styled from "styled-components";

const StyledCalendar = styled(Calendar)`
    width: 100%;
`;

const StyledCalendarLabel = styled.label`
    text-align: left;
    width: 100%;
    padding-bottom: 0.4rem;
`;

export default { StyledCalendar, StyledCalendarLabel };
